export const appRoutesUrls = {
    root: () => `/`,
    home: () => `/home`,
    aboutUs: () => `/about-us`,
    services: () => `/services`,
    contactUs: () => `/contact-us`,
    // Account
    account: () => `/account`,
    login: () => `/account/login`,
    register: () => `/account/register`,
    logout: () => `/account/logout`,
    unauthorized: () => `/account/unauthorized`,
    // Admin
    admin: () => `/admin`,
    dashboard: () => `/admin/dashboard`,
    // Admin/Roles
    roles: () => `/admin/roles`,
    roleAdd: () => `/admin/role`,
    roleEdit: (id) => `/admin/role/${id}/edit`,
    roleView: (id) => `/admin/role/${id}/view`,
    // Admin/Users
    users: () => `/admin/users`,
    userAdd: () => `/admin/user`,
    userEdit: (id) => `/admin/user/${id}/edit`,
    userView: (id) => `/admin/user/${id}/view`,
    // Admin/Customers
    customers: () => `/admin/customers`,
    customerAdd: () => `/admin/customer`,
    customerEdit: (id) => `/admin/customer/${id}/edit`,
    customerView: (id) => `/admin/customer/${id}/view`,
    customerInvoices: (id) => `/admin/customer/${id}/invoices`,    
    customerInvoiceAdd: (id) => `/admin/customer/${id}/invoice`,
    customerInvoiceItems: (id) => `/admin/customer/${id}/invoiceitems`,
    // Invoices
    invoices: () => `/admin/invoices`,
    invoicedetails: (id) => `/admin/invoice/${id}/details`,
}
